import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  exportUsageStats,
  getAdvisorMessageDistribution,
  getMyUsageStats,
  getUsageStatsAggregate,
} from '@/api/room'

export const fetchUsageStatsAggregate = createAsyncThunk(
  'usageStats/fetchAggregate',
  async (roomId: string, thunkAPI) => {
    try {
      return await getUsageStatsAggregate(roomId)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const fetchMyUsageStats = createAsyncThunk(
  'usageStats/fetchMine',
  async (roomId: string, thunkAPI) => {
    try {
      return await getMyUsageStats(roomId)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const downloadUsageStatsExport = createAsyncThunk(
  'usageStats/export',
  async (roomId: string, thunkAPI) => {
    try {
      return await exportUsageStats(roomId)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const fetchAdvisorMessageDistribution = createAsyncThunk(
  'usageStats/fetchAdvisorMessageDistribution',
  async (roomId: string, thunkAPI) => {
    try {
      return await getAdvisorMessageDistribution(roomId)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)
